module.exports = __webpack_public_path__ + "static/media/download-button.3902a491.svg";